import { render, staticRenderFns } from "./ReporteDescuentos.vue?vue&type=template&id=4ee06444&scoped=true"
import script from "./ReporteDescuentos.vue?vue&type=script&lang=js"
export * from "./ReporteDescuentos.vue?vue&type=script&lang=js"
import style1 from "./ReporteDescuentos.vue?vue&type=style&index=1&id=4ee06444&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee06444",
  null
  
)

export default component.exports